
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/shipping-policy",
      function () {
        return require("private-next-pages/about/shipping-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/shipping-policy"])
      });
    }
  